import { csrfToken } from './session';
export default function authHeader() {
  const token = csrfToken();
  return token ? { 'X-CSRF-Token': token } : {};
}
